import MaterialCard, { CardProps } from '@mui/material/Card';

export function Card(props: CardProps) {
    return <MaterialCard data-testid={'Card-container'} {...props} />;
}

export default Card;
